var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('div',[_c('img',{attrs:{"src":[
                _vm.theme === 'white'
                    ? require('@/assets/images/builderPage/nodata.png')
                    : require('@/assets/images/builderPage/nodata_black.png'),
            ],"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('text02')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }